import { render, staticRenderFns } from "./u-select-outlined-pill.vue?vue&type=template&id=7ea04200&scoped=true"
import script from "./u-select-outlined-pill.vue?vue&type=script&lang=js"
export * from "./u-select-outlined-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea04200",
  null
  
)

export default component.exports